import { Target } from "lucide-react";
import { useTranslation } from "react-i18next";

import type { HomeCardLayout } from "@/campaigns";
import type { MissionsCampaign } from "@/campaigns/modules/missions/types";
import {
  completedMissionCount,
  missionsTopPrize,
} from "@/campaigns/modules/missions/types";
import { CompactCampaignCard } from "@/components/campaign-card/campaign-card-compact";
import { formatPrizeTitle } from "@/utils/helpers";

export const MissionsHomeCard = ({
  missionsCampaign,
  layout,
}: {
  missionsCampaign: MissionsCampaign;
  layout: HomeCardLayout;
}) => {
  const { t } = useTranslation();
  const topPrize = missionsTopPrize(missionsCampaign);
  const done = completedMissionCount(missionsCampaign);
  const total = missionsCampaign.missions.length;

  return (
    <CompactCampaignCard
      campaign={missionsCampaign.campaign}
      typeLabel={t("missions.typeLabel", "Missions")}
      typeIcon={<Target />}
      hookValue={topPrize ? formatPrizeTitle(topPrize.title, t) : null}
      hookLabel={t("campaign.topPrize", "Top prize")}
      hookIsCatalogItem={topPrize?.is_catalog_item}
      metaExtra={
        done > 0
          ? t("missions.missionsDone", "{{done}} of {{total}} missions done", {
              done,
              total,
            })
          : undefined
      }
      layout={layout}
    />
  );
};
